import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LocationState } from './location.state';

export const selectLocationState = createFeatureSelector<LocationState>('location');

export const selectLocation = createSelector(
  selectLocationState,
  (state: LocationState) => state.location
);

export const selectLocationDisplayText = createSelector(
  selectLocation,
  (location) => {
    if (location?.city && location?.state) {
      return `${location.city}/ ${location.state}`;
    }
    return '';
  }
);

export const selectHasLocation = createSelector(
  selectLocation,
  (location) => !!(location?.city && location?.state)
);

export const selectRegionId = createSelector(
  selectLocation,
  (location) => location?.regionId ?? ''
);
